import gql from 'graphql-tag';

// The products a master may be added to on ONE payer side: active, in category
// DS_360 or DS_SELECT, and not already holding an active master on that side.
//
// A different question from `defaultCoverageMasterProducts`, which is "products
// that HAVE a master" and feeds the opt-out picker. `masterType` is required
// because the answer differs per side - one product can carry a buyer master and
// a seller master at the same time.
const defaultCoverageEligibleProductsQuery = gql`
  query GetDefaultCoverageEligibleProducts($masterType: String!) {
    defaultCoverageEligibleProducts(masterType: $masterType) {
      productId
      productCode
      productName
      categoryCode
    }
  }
`;

export default defaultCoverageEligibleProductsQuery;
